module.exports = __webpack_public_path__ + "6646c0f1359dab2a51ff54f0924945b6.svg";